import { render, staticRenderFns } from "./CresclabMenu.vue?vue&type=template&id=66071778&scoped=true&"
import script from "./CresclabMenu.vue?vue&type=script&lang=js&"
export * from "./CresclabMenu.vue?vue&type=script&lang=js&"
import style0 from "./CresclabMenu.vue?vue&type=style&index=0&id=66071778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66071778",
  null
  
)

export default component.exports